import { PlainObject } from "@core/models";
import { app, authentication } from "@microsoft/teams-js";
import { Logger } from "../Logger";

export const AuthHelper = Object.freeze({
    authenticate,
    getToken() {
        return sessionStorage.getItem("fuzion365_token");
    },
    getTokenExpiration() {
        const exp = sessionStorage.getItem("fuzion365_token_expiration");
        return exp ? parseInt(exp, 10) : null;
    },
    getUserData(token: string): PlainObject | null {
        try {
            const payload = token.split(".")[1];
            return JSON.parse(atob(payload));
        } catch (error) {
            Logger.error("Error decoding token", error);
            return null;
        }
    },
    isExpired() {
        const exp = AuthHelper.getTokenExpiration();
        if (exp == null) return true;
        const now = Math.floor(Date.now() / 1000);
        return now >= exp;
    },
    isLoggedIn() {
        return !!AuthHelper.getToken();
    },
});

async function authenticate(): Promise<string> {
    Logger.log("Authenticating...");
    if (AuthHelper.isExpired()) {
        Logger.log("Initializing authentication procedure...");
        await app.initialize();
        Logger.log("Requesting new authentication token...");
        const token = await authentication.authenticate({
            url: "/__auth/start",
            width: 600,
            height: 650,
        });
        const decodedToken = JSON.parse(atob(token.split(".")[1]));
        sessionStorage.setItem("fuzion365_token", token);
        sessionStorage.setItem("fuzion365_token_expiration", decodedToken.exp);
        Logger.log("Authentication successful!");
        return token;
    } else {
        Logger.log("Authenticated!");
        return AuthHelper.getToken()!;
    }
}